__turbopack_context__.v({
  "container": "_7tn7AW_container",
  "icon": "_7tn7AW_icon",
});
